import type { ItemName } from '@ps-smart-cp/ppfw-client';
import { Button, ButtonGroup, buttonName, useItemName, useItemNames } from '@ps-smart-cp/ppfw-client';

interface Props {
  navigateButtonItemName: ItemName;
  onNavigate: () => void;
  onRegister: () => void;
  onReset: () => void;
}

export function CustomFieldSettingFooterButton(props: Props) {
  const { navigateButtonItemName, onNavigate, onRegister, onReset } = props;

  const getItemName = useItemName();
  const getButtonName = useItemNames(buttonName);

  return (
    <ButtonGroup alignment="right">
      <Button label={getItemName(navigateButtonItemName)} onClick={onNavigate} />
      <Button label={getButtonName('register')} onClick={onRegister} />
      <Button label={getButtonName('reset')} onClick={onReset} />
    </ButtonGroup>
  );
}
